// extracted by mini-css-extract-plugin
module.exports = {"noPlaceSelected":"src-common-list-item-selector-actions-on-seleted__noPlaceSelected--3Zzxq"};